<!-- Header -->
<div mat-dialog-title
	role="heading">
	File Too Large
</div>

<!-- Footer -->
<mat-dialog-content>
	<div [innerHtml]="message"></div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>
	<tyl-button image="Cancel.png"
		label="Close"
		(clickEvent)="close()"></tyl-button>
</mat-dialog-actions>